module.exports = __webpack_public_path__ + "img/google_import_002.6ebb5e3a.png";